module.exports = {"id":"224422","name":"Jérémie Boga","rating":"71","photo":"./data/images/photos/3/224422.png","club":{"name":"Birmingham City","logo":"./data/images/clubs/BirminghamCity.png"},"positions":["MG","MD","BU","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JeremieBoga0.json
// module id = 1982
// module chunks = 0